import { scheduleDraftReferenceApi } from "../../../api/v3/scheduleDraftReferenceApi";
import { unwrapV3ResponseData } from "../../../api/v3/responseContract";
import { normalizeAircraftRegistrations } from "./aircraftAvailabilityConstraints";

export const aircraftAvailabilityQueryKeys = {
    all: ["reference", "aircraftAvailabilityWindows"],
    windows: (registrations = [], start = "", end = "", status = "ACTIVE") => [
        ...aircraftAvailabilityQueryKeys.all,
        normalizeAircraftRegistrations(registrations),
        start || "",
        end || "",
        status || "all",
    ],
};

export async function getAircraftAvailabilityWindows({
    registrations = [],
    start,
    end,
    status = "ACTIVE",
} = {}) {
    const normalizedRegistrations = normalizeAircraftRegistrations(registrations);
    if (!normalizedRegistrations.length || !start || !end) {
        return {};
    }
    const response = await scheduleDraftReferenceApi.getAircraftAvailabilityWindows({
        registrations: normalizedRegistrations.join(","),
        start,
        end,
        status,
    });
    const payload = unwrapV3ResponseData(response);
    return payload && typeof payload === "object" && !Array.isArray(payload) ? payload : {};
}
